import React from "react";
import Styleabout from "./about.module.css";
import { motion } from "framer-motion";
import ValuesImg from "../../Ui/values.jpg";
import Cover from "../cover";
import AboutCover from "../../Ui/aboutImage.jpeg";
import AboutCover1 from "../../Ui/aboutImage1.jpg";
import AboutCover2 from "../../Ui/aboutImage2.jpg";
import AboutImg from "../../Ui/aboutimage.jpg";
import { IoIosArrowDown } from "react-icons/io";
import { FaHeart, FaLightbulb, FaAward } from "react-icons/fa";

const About = () => {
  return (
    <>
      <Cover
        images={[AboutCover, AboutCover1, AboutCover2]}
        heading="About Us"
        subHeading="Committed to compassionate and exceptional care."
      />

      <div className={Styleabout.maincontainer}>
        <motion.div
          className={Styleabout.toptext}
          initial={{ opacity: 0, y: 100 }}
          whileInView={{ opacity: 1, y: 0 }}
          transition={{ duration: 1.5 }}
        >
          <h1>About Our Hospital</h1>
          <h3>Welcome to our hospital's digital home</h3>
          <p>
            Our mission is to provide outstanding healthcare with compassion,
            innovation, and excellence. From emergency treatments to specialized
            care, we are here to serve with dignity and dedication.
          </p>
        </motion.div>

        <motion.div
          className={Styleabout.arrowdown}
          animate={{ y: [0, 10, 0] }}
          transition={{ repeat: Infinity, duration: 1.2 }}
        >
          <IoIosArrowDown size={36} color="#555" />
        </motion.div>

        <motion.div
          className={Styleabout.aboutimg}
          initial={{ opacity: 0, x: -100 }}
          whileInView={{ opacity: 1, x: 0 }}
          transition={{ duration: 1 }}
        >
          <h2>
            Healthcare is more than treating illnesses—it's about restoring
            dignity, quality of life, and hope. For years, we've served our
            community with unwavering commitment.
          </h2>
          {/* <div className={Styleabout.valuesimage}>
            <motion.img
              src={ValuesImg}
              alt="Our Values"
              initial={{ scale: 0.9 }}
              whileHover={{ scale: 1.02 }}
              transition={{ duration: 0.4 }}
            />
          </div> */}
        </motion.div>

        <motion.div
          className={Styleabout.valuesBoxes}
          initial={{ opacity: 0, y: 50 }}
          whileInView={{ opacity: 1, y: 0 }}
          transition={{ duration: 1.2 }}
        >
          <motion.div
            className={Styleabout.valueCard}
            initial={{ opacity: 0, scale: 0.8, y: 50 }}
            whileInView={{ opacity: 1, scale: 1, y: 0 }}
            whileHover={{ scale: 1.05 }}
            transition={{
              stiffness: 200,
              duration: 0.8,
              ease: "easeOut",
              type: "spring",
              delay: 1 * 0.3,
            }}
          >
            <div className={Styleabout.icon}>
              <FaHeart />
            </div>

            <h3>Compassion</h3>
            <p>We treat every patient with empathy, respect, and care.</p>
          </motion.div>

          <motion.div
            className={Styleabout.valueCard}
            initial={{ opacity: 0, scale: 0.8, y: 50 }}
            whileInView={{ opacity: 1, scale: 1, y: 0 }}
            whileHover={{ scale: 1.05 }}
            transition={{
              stiffness: 200,
              duration: 0.8,
              ease: "easeOut",
              type: "spring",
              delay: 2 * 0.3,
            }}
          >
            <div className={Styleabout.icon}>
              <FaLightbulb />
            </div>
            <h3>Innovation</h3>
            <p>We stay ahead with cutting-edge technology and research.</p>
          </motion.div>

          <motion.div
            className={Styleabout.valueCard}
            initial={{ opacity: 0, scale: 0.8, y: 50 }}
            whileInView={{ opacity: 1, scale: 1, y: 0 }}
            whileHover={{ scale: 1.05 }}
            transition={{
              stiffness: 200,
              duration: 0.8,
              ease: "easeOut",
              type: "spring",
              delay: 3 * 0.3,
            }}
          >
            <div className={Styleabout.icon}>
              <FaAward />
            </div>

            <h3>Excellence</h3>
            <p>We deliver the highest standard of care in all we do.</p>
          </motion.div>
        </motion.div>
      </div>
    </>
  );
};

export default About;
